var render = function render(){var _vm=this,_c=_vm._self._c;return _c('login-personalize-preview-panel-section',{staticClass:"login-personalize-preview-section-local"},[_c('login-personalize-local-modal',{attrs:{"item":_vm.item},on:{"saved":_vm.emitSaved},model:{value:(_vm.showingLocalModal),callback:function ($$v) {_vm.showingLocalModal=$$v},expression:"showingLocalModal"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }